import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Layout from "./components/layout/Layout";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";

import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Curriculum from "./pages/Curriculum";

import "./App.css";

function App() {
  return (
    <Router>
       
  <ScrollToTop />
  

      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="contact" element={<Contact />} />
          <Route path="curriculum" element={<Curriculum />} />
        </Route>
      </Routes>
    </Router>
  );
 
}

export default App;